export class ReportService {

  openPdf = (result: any) => {
    const blob = new Blob([result.data], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(blob);
    window.open(fileURL, "_blank");
  }

  downloadPdf = (pdfBase64: string, name: string) => {
    const link = document.createElement('a');
    link.href = `data:application/pdf;base64,${pdfBase64}`;
    link.download = `${name}.pdf`;
    link.click();
  }

  download = (result: any, name: string) => {
    const blob = new Blob([result.data], { type: 'application/octet-stream' });
    const fileURL = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = fileURL;
    link.download = name;

    document.body.appendChild(link);

    link.dispatchEvent(
      new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      })
    );

    document.body.removeChild(link);
  }

  downloadCsvFromString = (data: string, name: string) => {
    const blob = new Blob([data], { type: 'text/csv' });
    const fileURL = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = fileURL;
    link.download = name;

    document.body.appendChild(link);

    link.dispatchEvent(
      new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      })
    );

    document.body.removeChild(link);
  }
}